"use client";

import type { UseQueryResult } from "@tanstack/react-query";

import type { RadioStationDetails } from "../../../lib/types/schema/radio-station/radioStationDetailsSchema";
import { radioStationDetailsSchema } from "../../../lib/types/schema/radio-station/radioStationDetailsSchema";
import type { UseRequestQueryProps } from "../../../request/hooks/useRequestQuery";
import { useRequestQuery } from "../../../request/hooks/useRequestQuery";
import { keyRadioStation } from "./keyRadioStation";

export type UseRequestRadioStationProps = UseRequestQueryProps & {
  id: number;
};

export const useRequestRadioStation = ({
  id,
  ...props
}: UseRequestRadioStationProps) => ({
  query: useRequestQuery({
    ...props,
    enabledWithoutSessionToken: false,
    queryKey: keyRadioStation({ id }),
    queryFnRequestProps: {
      schema: radioStationDetailsSchema,
      urlBackendPath: `/radio-station-details/${id}`,
    },
  }) as UseQueryResult<RadioStationDetails>,
});
